/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Tab_Manage1Inputs */

const vi_guidevideo_tab_manage1 = /** @type {(inputs: Guidevideo_Tab_Manage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý`)
};

/**

* @param {Guidevideo_Tab_Manage1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_tab_manage1 = /** @type {((inputs?: Guidevideo_Tab_Manage1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Tab_Manage1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_tab_manage1(inputs)
});
export { guidevideo_tab_manage1 as "guideVideo_tab_manage" }